import { useEffect } from 'react';
import { navigate } from 'gatsby';
import { getQueryParam } from 'lib/util';
import { Loading } from '../../components';
import { useClearUserState, useLogin } from '../../hooks';

const ImpersonateRedirectPage = () => {
  const clearUserState = useClearUserState();
  const login = useLogin();
  const queryToken = getQueryParam('token');

  useEffect(() => {
    if (!queryToken) {
      navigate('/');
      return null;
    }

    clearUserState();
    login(queryToken, { redirectPath: '/' });
  }, []);

  return <Loading />;
};

export default ImpersonateRedirectPage;
